'use client'

export default function DealsEmptyState({
  origin, destFilter, weekendOnly, stopsFilter,
  setWeekendOnly, setStopsFilter, updateDestFilter,
  isPaid, dealCounts, airports, currentUser, setShowModal, onSwitchAirport,
  regionFilter, lockedInRegion,
}) {
  const REGION_LABELS = {
    asia: 'Asia', americas: 'Americas', middle_east: 'Middle East',
    africa: 'Africa', oceania: 'Oceania',
  }
  const bestAirport = [...airports].sort((a, b) => (dealCounts[b] ?? 0) - (dealCounts[a] ?? 0))[0]
  const bestCount = bestAirport ? (dealCounts[bestAirport] ?? 0) : 0

  return (
    <div className="mt-8 rounded-xl border border-gray-200 bg-white p-6 text-center shadow-sm">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" className="mx-auto mb-1" aria-hidden="true">
        <path d="M4 48 L60 4 L44 72 L28 50 Z" fill="#dbeafe"/>
        <path d="M60 4 L44 72 L28 50 Z" fill="#93c5fd"/>
        <line x1="4" y1="48" x2="28" y2="50" stroke="#93c5fd" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="56" cy="56" r="17" fill="white" fillOpacity="0.95" stroke="#60a5fa" strokeWidth="2.5"/>
        <line x1="68" y1="68" x2="76" y2="76" stroke="#60a5fa" strokeWidth="3" strokeLinecap="round"/>
        <line x1="49" y1="56" x2="63" y2="56" stroke="#bfdbfe" strokeWidth="2" strokeLinecap="round"/>
        <line x1="56" y1="49" x2="56" y2="63" stroke="#bfdbfe" strokeWidth="2" strokeLinecap="round"/>
      </svg>
      <p className="mt-3 font-semibold text-gray-800">
        {origin ? `No deals from ${origin}${destFilter.length > 0 ? ` to ${destFilter.join(', ')}` : ''}${weekendOnly ? ' for 2–3 nights' : ''} today` : 'No deals found'}
      </p>
      {weekendOnly ? (
        <>
          <p className="mt-1 text-sm text-gray-400">No short-trip deals right now. Try removing the weekend filter.</p>
          <button onClick={() => setWeekendOnly(false)} className="mt-2 text-sm text-violet-600 hover:underline">
            Remove weekend filter
          </button>
        </>
      ) : stopsFilter === 'direct' ? (
        <>
          <p className="mt-1 text-sm text-gray-400">No direct flights found &mdash; try &lsquo;Max 1 stop&rsquo;</p>
          <button onClick={() => { setStopsFilter('max1'); localStorage.setItem('ff_stops_filter', 'max1') }} className="mt-2 text-sm text-blue-600 hover:underline">
            Show max 1 stop
          </button>
        </>
      ) : stopsFilter === 'max1' ? (
        <>
          <p className="mt-1 text-sm text-gray-400">No deals with max 1 stop — try showing all flights.</p>
          <button onClick={() => { setStopsFilter('all'); localStorage.setItem('ff_stops_filter', 'all') }} className="mt-2 text-sm text-blue-600 hover:underline">
            Show all stops
          </button>
        </>
      ) : destFilter.length > 0 ? (
        <>
          <p className="mt-1 text-sm text-gray-400">Try clearing the destination filter to see all routes.</p>
          <button onClick={() => updateDestFilter([])} className="mt-2 text-sm text-blue-600 hover:underline">
            Clear destination filter
          </button>
        </>
      ) : regionFilter && regionFilter !== 'all' && regionFilter !== 'europe' && lockedInRegion > 0 ? (
        <>
          <p className="mt-1 text-sm text-gray-500">
            <strong>{lockedInRegion} {REGION_LABELS[regionFilter] ?? regionFilter} deal{lockedInRegion !== 1 ? 's' : ''}</strong> available — these are Pro plan deals.
          </p>
          <p className="mt-1 text-xs text-gray-400">Long-haul and intercontinental routes are available on the Pro plan.</p>
          <div className="mt-4 flex flex-wrap gap-2 justify-center">
            {!currentUser && (
              <button onClick={() => setShowModal(true)} className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 transition-colors">
                Create free account
              </button>
            )}
            <a href="/pricing" className="rounded-lg border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 transition-colors">
              See Pro plan →
            </a>
          </div>
        </>
      ) : (
        <p className="mt-1 text-sm text-gray-400">We check every hour, around the clock — new deals could land any time.</p>
      )}
      {isPaid && bestAirport && bestAirport !== origin && bestCount > 0 && (
        <button
          onClick={() => onSwitchAirport?.(bestAirport)}
          className="mt-4 inline-flex items-center gap-1 rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
        >
          See {bestCount} deal{bestCount !== 1 ? 's' : ''} from {bestAirport} →
        </button>
      )}
      {!currentUser && (
        <p className="mt-4 text-sm text-gray-500">
          <button onClick={() => setShowModal(true)} className="font-semibold text-blue-600 hover:underline">
            Sign in to see all
          </button>
          {' '}to be the first to know when {origin} deals go live.
        </p>
      )}
    </div>
  )
}
